import * as api from "./api";
import { INIT, LOADING, SUCCESS, ERROR } from "../../constants/phase";
import { getMissionAndEventMapping } from "../../utils/missionAndReward/getMissionAndEventMapping";
import { mergeMissionAndEventMapping } from "../../utils/missionAndReward/mergeMissionAndEventMapping";
/***********************************
 * Action Types
 ***********/
// export const TOGGLE_USER_MISSIONS_POPOVER = "TOGGLE_USER_MISSIONS_POPOVER";
// export const UPDATE_VIEWING_USER_MISSION_ID = "UPDATE_VIEWING_USER_MISSION_ID";
// export const UPDATE_USER_MISSIONS = "UPDATE_USER_MISSIONS";
// export const UPDATE_USER_MISSIONS_PHASE = "UPDATE_USER_MISSIONS_PHASE";
// export const GET_ENROLLMENTS = "GET_ENROLLMENTS";
export const TRACK_ENROLLMENT_PROGRESS = "TRACK_ENROLLMENT_PROGRESS";
export const UPDATE_GET_ENROLLMENTS_PHASE = "UPDATE_GET_ENROLLMENTS_PHASE";
export const AUTO_ENROLL = "AUTO_ENROLL";
export const UPDATE_AUTO_ENROLL_PHASE = "UPDATE_AUTO_ENROLL_PHASE";
// export const UPDATE_PUBLIC_TRACKABLE_EVENTS = "UPDATE_PUBLIC_TRACKABLE_EVENTS";
// export const TRACK_PUBLIC_EVENT = "TRACK_PUBLIC_EVENT";
/***********************************
 * Initial State
 ***********/
const initialState = {
  getEnrollmentsPhase: INIT,
  trackEnrollmentPhase: INIT,
  publicTrackableEventsPhase: INIT,
  enrollments: [],
  availableMissionPlans: [],
  missionAndEventMapping: {},
  rewardSummary: {},
  autoEnrollPhase: INIT,
  missionEnrollmentVersion: null,
  publicTrackableEvents: {}
};

/***********************************
 * Reducer
 ***********/
export default function(state = initialState, action = {}) {
  switch (action.type) {
    // case GET_ENROLLMENTS:
    //   return {
    //     ...state,
    //     getEnrollmentsPhase: SUCCESS,
    //     enrollments: action.payload.enrollments
    //   };
    case UPDATE_AUTO_ENROLL_PHASE:
      return {
        ...state,
        autoEnrollPhase: action.payload
      };
    case AUTO_ENROLL:
      const timeEnd = action.payload.enrollments.map(enrollment => new Date(enrollment.executionTimeRange.endAt).getTime());
      const enrollmentExpirationTimestamp = timeEnd.reduce((acc, curr) => Math.min(acc, curr), Infinity);
      console.log("M&R ::: Enrollment Expiration Timestamp: ", enrollmentExpirationTimestamp)
      console.log("MissionAndReward ::: AUTO_ENROLL PAYLOAD: ", action.payload);
      return {
        ...state,
        autoEnrollPhase: SUCCESS,
        enrollments: action.payload.enrollments,
        missionAndEventMapping: action.payload.missionAndEventMapping,
        rewardSummary: action.payload.rewardSummary,
        missionEnrollmentVersion: action.payload.missionEnrollmentVersion,
        enrollmentExpirationTimestamp: enrollmentExpirationTimestamp
      };
    case UPDATE_GET_ENROLLMENTS_PHASE:
      return {
        ...state,
        getEnrollmentsPhase: action.payload
      };
    case TRACK_ENROLLMENT_PROGRESS:
      const { enrollments, userRewardSummary } = action.payload;

      const updatedEnrollments = state.enrollments.map(e => {
        if (enrollments.find(enrollment => enrollment._id === e._id)) {
          return enrollments.find(enrollment => enrollment._id === e._id);
        }
        return e;
      });
      return {
        ...state,
        enrollments: updatedEnrollments || [],
        rewardSummary: userRewardSummary
      };
    // case UPDATE_PUBLIC_TRACKABLE_EVENTS:
    //   console.log(
    //     "MissionAndReward ::: UPDATE_PUBLIC_TRACKABLE_EVENTS PAYLOAD: ",
    //     action.payload
    //   );
    //   return {
    //     ...state,
    //     publicTrackableEvents: action.payload
    //   };
    // case TRACK_PUBLIC_EVENT:
    //   return {
    //     ...state,
    //     publicTrackableEventsPhase: SUCCESS
    //   };
    default:
      return state;
  }
}

/***********************************
 * Action Creators
 ***********/
export const autoEnroll = () => async (dispatch, getState) => {
  const {
    autoEnrollPhase,
    enrollmentExpirationTimestamp
  } = getState().missionAndReward;
  if (autoEnrollPhase === LOADING) {
    return;
  }
  const autoEnrollPhaseSuccessCheck =
    autoEnrollPhase !== LOADING && autoEnrollPhase === SUCCESS;
  const autoEnrollPhaseInitCheck =
    autoEnrollPhase !== LOADING && autoEnrollPhase === INIT;

  // GET UTC 16:00 in timestamp
  const now = new Date();
  const enrollmentExpirationTimestampCheck = now.getTime() > enrollmentExpirationTimestamp;
  if (
    autoEnrollPhaseInitCheck ||
    (autoEnrollPhaseSuccessCheck && enrollmentExpirationTimestampCheck)
  ) {
    try {
      console.log("M&R ::: Auto Enroll ::: Try to auto enroll");
      dispatch({
        type: UPDATE_AUTO_ENROLL_PHASE,
        payload: LOADING
      });
      const { enrollments, rewardSummary } = await api.autoEnrollApi();

      const missionAndEventMapping = enrollments.map(enrollment =>
        getMissionAndEventMapping(enrollment)
      );
      const mergedMissionAndEventMapping = mergeMissionAndEventMapping({
        missionAndEventMapping: missionAndEventMapping
      });
      dispatch({
        type: AUTO_ENROLL,
        payload: {
          enrollments: enrollments,
          missionAndEventMapping: mergedMissionAndEventMapping,
          rewardSummary: rewardSummary,
          autoEnrollPhase: SUCCESS,
          missionEnrollmentVersion: now.getTime()
        }
      });
      // console.log("M&R --- AutoEnroll completed. new dispatch version: ", now.getTime());
    } catch (error) {
      console.log("M&R ::: Auto Enroll Error: ", error);
      return error;
    }
  }
};

export const trackMissionProgress = ({
  sources,
  value,
  action
}) => async dispatch => {
  try {
    const response = await api.trackMissionProgressApi({
      sources,
      value,
      action
    });
    dispatch({
      type: TRACK_ENROLLMENT_PROGRESS,
      payload: response
    });
  } catch (error) {
    console.log("DISPATCH TRACK ENROLLMENT PROGRESS: ERROR", error);
    return error;
  }
};


// Note: Currently, everytime user fire trackDirectAnonymous, we will fire Mission and reward, publicTrackByEvent
// export const initPublicTrackableEvents = userId => async dispatch => {
//   console.log("MissionAndReward ::: initPublicTrackableEvents ::: userId: ", userId);
//   try {
//     if (!userId) {
//       return;
//     }
//     const publicTrackableEvents = await api.initPublicTrackableEventsApi( userId );
//     if (publicTrackableEvents.length > 0) {
//       dispatch({
//         type: UPDATE_PUBLIC_TRACKABLE_EVENTS,
//         payload: publicTrackableEvents
//       });
//     }
//   } catch (error) {
//     console.log("DISPATCH INIT PUBLIC TRACKABLE EVENTS: ERROR", error);
//     return error;
//   }
// };
